import { useEffect, useState } from "react";
import { message } from "antd";

import ProductosHeader from "./ProductosHeader";
import ProductosCards from "./ProductosCards";
import ProductosFilters from "./components/ProductosFilters";
import ProductosTable from "./components/ProductosTable";
import ProductoForm from "./components/ProductoForm";
import ProductosBulkForm from "./components/ProductosBulkForm";
import dayjs from "dayjs";
import { useSelector } from 'react-redux';
import { selectAppPermissions } from '../../../store/auth/selectors';
import { getProductos, deleteProducto } from "../../../services/financiero/finProductosService";

export default function ProductosPage() {

  const [productos, setProductos] = useState([]);
  const [filteredProductos, setFilteredProductos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [productoEdit, setProductoEdit] = useState(null);
  const [openForm, setOpenForm] = useState(false);
  const [openBulk, setOpenBulk] = useState(false);
  const appName = 'productos_financiero';
  const permissions = useSelector((state) => selectAppPermissions(state, appName));
  const user = useSelector((state) => state.auth.user);
  const userLogin = user.username;
  const permissionAccess = permissions.priv_access === 'Y';
  const permissionDelete = permissions.priv_delete === 'Y';
  const permissionUpdate = permissions.priv_update === 'Y';
  const permissionInsert = permissions.priv_insert === 'Y';
  const permissionExport = permissions.priv_export === 'Y';

  const cargarProductos = async () => {
    setLoading(true);

    try {
      const res = await getProductos();
      setProductos(res);
      setFilteredProductos(res);
    }
    catch {
      message.error("Error cargando productos");
    }

    setLoading(false);
  }

  useEffect(() => {
    cargarProductos();
  }, [])

  const handleDelete = async (record) => {
    try {
      await deleteProducto(record.oid, userLogin);
      message.success("Producto eliminado");
      cargarProductos();
    }
    catch {
      message.error("Error eliminando producto");
    }

  }

  const handleEdit = (record) => {

    if (!permissionUpdate) {
      message.warning("No tiene permisos para editar");
      return;
    }

    const data = {
      ...record,
      fecha_estimada_entrega: record.fecha_estimada_entrega
        ? dayjs(record.fecha_estimada_entrega)
        : null
    };

    setProductoEdit(data);
    setOpenForm(true);
  };

  const handleCreate = () => {

    if (!permissionInsert) {
      message.warning("No tiene permisos para crear productos");
      return;
    }

    setProductoEdit(null);
    setOpenForm(true);
  }

  const handleFilters = (filters) => {

    let data = [...productos];

    if (filters.search) {
      data = data.filter(p =>
        p.nombre_producto?.toLowerCase()
          .includes(filters.search.toLowerCase())
      )
    }

    if (filters.po) {
      data = data.filter(p =>
        p.Numero_PO?.toLowerCase()
          .includes(filters.po.toLowerCase())
      )
    }

    if (filters.proveedor) {
      data = data.filter(p =>
        p.oid_proveedor === filters.proveedor
      )
    }

    if (filters.estado) {
      data = data.filter(p =>
        p.oid_estado === filters.estado
      )
    }

    if (filters.localizacion) {
      data = data.filter(p =>
        p.localizacion?.toLowerCase()
          .includes(filters.localizacion.toLowerCase())
      )
    }

    setFilteredProductos(data);

  }

  if (!permissionAccess) {
    return <div>No tiene permisos para acceder a este módulo</div>;
  }

  return (
    <div className="container">
      <ProductosHeader
        onCreate={handleCreate}
        onBulkCreate={() => setOpenBulk(true)}
        onRefresh={cargarProductos}
        permissionInsert={permissionInsert}
        
      /> 
      <ProductosCards
        productos={filteredProductos}
      />
      <ProductosFilters
        onFilter={handleFilters}
        filteredProductos={filteredProductos}
        permissionExport={permissionExport}
      />
      <ProductosTable
        data={filteredProductos}
        loading={loading}
        onEdit={handleEdit}
        onDelete={handleDelete}
        permissionDelete={permissionDelete}
        permissionUpdate={permissionUpdate}
      />
      <ProductoForm
        open={openForm}
        producto={productoEdit}
        onClose={() => setOpenForm(false)}
        onSuccess={cargarProductos}
        userLogin={userLogin}
      />
      <ProductosBulkForm
        open={openBulk}
        onClose={() => setOpenBulk(false)}
        onSuccess={cargarProductos}
        userLogin={userLogin}
      />
    </div>
  )

}